import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';

// const getEventsDetailsData = async (user, event_status, search_text,page, page_size,filter) => {

//   const storageAvailable = localStorageAvailable();
//   const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

//   const {capacity_from, capacity_to, event_from_date, event_till_date } = filter;
//   const config = {
//     method: 'get',
//     maxBodyLength: Infinity,
//     url: `/service/events_service/v1/events/event/admin/all`,
//     headers: {
//       authorization: `Bearer ${accessToken}`,
//       user
//     },
//     params: {
//       event_status,
//       page,
//       page_size,
//       search: search_text,
//       capacity_from,
//       capacity_to,
//       event_from_date,
//       event_till_date,
//     }
//   };
//   const response = await axios.request(config);
//   console.log(response);

//   return response?.data;
// };

const getSelfVendorEventsDetails = async (user, event_status, search, page, page_size, filter, review_status) => {
  const storageAvailable = localStorageAvailable();
  const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';
  const mode = localStorage.getItem('mode');

  const { capacity_from, capacity_to, event_from_date, event_till_date, vendor_id } = filter;

  // Build params conditionally
  const params = {
    page,
    event_status,
    search,
    page_size,
    capacity_from,
    capacity_to,
    event_from_date,
    event_till_date,
    mode,
    vendor_id,
    review_status
  };

  const config = {
    method: 'get',
    url: `/service/events_service/v1/events/event/admin/self_vendor`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      user,
    },
    params,
  };

  try {
    const response = await axios.request(config);
    // console.log('Response Data:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching event details:', error);
    throw error;
  }
};

export default getSelfVendorEventsDetails;
